import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PostRenewalInformationFailure, PostRenewalInformationRequest, PostRenewalInformationSuccess } from './actions';
import { PostRenewalInformationService } from './service';

@Injectable()
export class PostRenewalInformationEffects {
  private readonly actions$ = inject(Actions);
  private readonly postRenewalInformationFlowService = inject(PostRenewalInformationService);

  postRenewalInformationFlow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostRenewalInformationRequest),
      switchMap(({ body, parameters }) =>
        this.postRenewalInformationFlowService.postRenewalInformation(body, parameters).pipe(
          map(data => PostRenewalInformationSuccess({ data })),
          catchError(error => of(PostRenewalInformationFailure({ error })))
        )
      )
    )
  );

}
